import { m as motion } from "framer-motion";

/**
 * Line-by-line masked reveal, editorial cinematic on-load moment.
 * Lines: array of strings. Each becomes a mask that rises from below.
 */
export default function KineticLines({ lines = [], delay = 0, className = "", lineClassName = "" }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`reveal-line ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: [0.19, 1, 0.22, 1], delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
